// extracted by mini-css-extract-plugin
export var availabilityText = "CustomerServicePopup-module--availabilityText--LMHOp";
export var avatar = "CustomerServicePopup-module--avatar--Y6DQE";
export var closeButton = "CustomerServicePopup-module--closeButton--yLmHN";
export var contactItem = "CustomerServicePopup-module--contactItem--taQ6M";
export var contactItemBorder = "CustomerServicePopup-module--contactItemBorder--2pZa0";
export var contactItemIconTitle = "CustomerServicePopup-module--contactItemIconTitle--haOeO";
export var contactMethods = "CustomerServicePopup-module--contactMethods--Buhtp";
export var content = "CustomerServicePopup-module--content--wCoUJ";
export var customerServInfo = "CustomerServicePopup-module--customerServInfo--wuoZj";
export var customerServInfoAvailability = "CustomerServicePopup-module--customerServInfoAvailability--Dr8Nq";
export var customerServInfoTitle = "CustomerServicePopup-module--customerServInfoTitle--06l7g";
export var fadeIn = "CustomerServicePopup-module--fadeIn--oSOUb";
export var header = "CustomerServicePopup-module--header--1xWiC";
export var modalOpen = "CustomerServicePopup-module--modal-open--iXYwF";
export var open = "CustomerServicePopup-module--open--VUEnW";
export var overlay = "CustomerServicePopup-module--overlay--3wWp9";
export var popup = "CustomerServicePopup-module--popup--ZZOk4";
export var status = "CustomerServicePopup-module--status--T6dRs";
export var statusDotAvailable = "CustomerServicePopup-module--statusDotAvailable--TJz72";
export var statusDotUnavailable = "CustomerServicePopup-module--statusDotUnavailable--veBTz";